import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    error: 'An error occurred. Please try again.',
    monthly: 'Every month',
    quarterly: 'Every quarter',
    title: 'Your declaration frequency',
  },
  fr: {
    error: 'Une erreur est survenue. Veuillez réessayer.',
    monthly: 'Tous les mois',
    quarterly: 'Tous les trimestres',
    title: 'Votre périodicité de déclaration',
  },
} as const);
